"use strict";

/* todo: I want this to actually be an array of Function | string but that causes errors */
Object.defineProperty(module.exports, "babelPluginFlowReactPropTypes_proptype_GlamorRule", {
  value: require("react").PropTypes.shape({
    cssText: require("react").PropTypes.string.isRequired
  })
});

/* eslint-disable no-undef */


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/types.js
// module id = 7
// module chunks = 0